import React from "react";
import st from "@/styles/LoginPage.module.scss"
import StepOneForm from "./StepOneForm.tsx"
import StepTwoForm from "./StepTwoForm.tsx"
import StepThreeForm from "@/pages/login/elemsV2/StepThreeForm.tsx";



interface Props {
    step:number
}

const LoginForm:React.FC<Props> = ({ step}) => {
    
    
    return (
        <div className={st.login_form_contaienr}>
            
            {step === 1 && (
                <StepOneForm />
            )}
            
            {step === 2 && (
                <StepTwoForm />
            )}
            
            {step === 3 && (
                <StepThreeForm />
            )}
            
        </div>
    )
}

export default LoginForm